var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout"},[_c('el-container',[_c('el-aside',{attrs:{"width":"200px"}},[_c('layout-aside')],1),_c('el-container',[_c('el-header',{staticClass:"p-0",attrs:{"height":"70px"}},[_c('layout-header')],1),_c('el-main',[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }